module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.titleLogsReq + ' Lote ' + this.formData.lote,
      "width": "60%",
      "modal": _vm.showLogsReq,
      "isModal": false
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('XmlViewer', {
    attrs: {
      "xml": _vm.messageLogsReq
    }
  })], 1)], 1), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'STATUS PROCESSAMENTO -  ' +
        (_vm.formDataLogs.protocolo ? _vm.formDataLogs.protocolo : ''),
      "width": "60%",
      "modal": _vm.showLogs,
      "isModal": false
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")])])]), _vm._v(" "), _vm._l((_vm.formDataLogs.log_retorno), function(retorno, i) {
    return _c('tbody', {
      key: i
    }, [_c('tr', [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(retorno.cdResposta))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(retorno.descResposta))])]), _vm._v(" "), (retorno.uid) ? _c('tr', [_c('td', {
      staticStyle: {
        "background": "#fce6d9"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('b', [_vm._v("Arquivo")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background": "#fce6d9"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(retorno.uid))]), _vm._v(" "), (retorno.recibo) ? _c('label', {
      staticStyle: {
        "color": "green"
      }
    }, [_c('b', [_vm._v("Recibo: ")]), _vm._v(" " + _vm._s(retorno.recibo) + "\n              ")]) : _vm._e(), _vm._v(" "), (retorno.funcionario) ? _c('label', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v("\n                " + _vm._s(retorno.funcionario) + "\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (retorno.ocorrencias) ? _vm._l((retorno.ocorrencias), function(ocorrencia, j) {
      return _c('tr', {
        key: i + j
      }, [_c('td', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "align": "left"
        }
      }, [_vm._v("\n                " + _vm._s(ocorrencia.codigo) + "\n              ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "align": "left"
        }
      }, [_vm._v("\n                " + _vm._s(ocorrencia.descricao) + " "), (ocorrencia.localizacao) ? _c('span', [_vm._v("em " + _vm._s(ocorrencia.localizacao))]) : _vm._e()])])
    }) : _vm._e()], 2)
  })], 2)])], 1), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "SELECIONE O MODO DE TRANSMISSÃO DO ARQUIVO",
      "modal": _vm.showModo,
      "isModal": false,
      "width": "70%"
    }
  }, [_c('el-row', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "show-icon": "",
      "closable": false
    }
  }, [_c('b', [_vm._v("ORIENTAÇÕES")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Inclusão:")]), _vm._v("\n        Selecione esta opção na primeira vez que enviar o lote ou quando a\n        tentativa de inclusão foi rejeitada.\n        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Alteração:")]), _vm._v("\n        Selecione esta opção para alterar o evento. Nesse ponto deve existir\n        um lote de inclusão enviado.\n        "), _c('br'), _vm._v(" "), (_vm.tableData && _vm.tableData.length > 0) ? _c('span', {
    staticStyle: {
      "color": "#21bc4d"
    }
  }, [_c('b', [_vm._v("Último Lote Enviado:")]), _vm._v("\n          " + _vm._s(_vm.parseModo(_vm.tableData[0]._data.modo)) + " em\n          " + _vm._s(_vm.toDate(_vm.tableData[0]._data.created_at, false)) + "\n\n          "), (_vm.tableData[0]._data.status != '201') ? _c('span', {
    staticStyle: {
      "font-size": "9pt",
      "color": "red"
    }
  }, [_c('br'), _vm._v("Lote não processado. Verifique o detalhamento do\n            processamento.")]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'inc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Inclusão\n        ")]), _vm._v(" "), (_vm.formData && _vm.formData.layout != 'S-3000') ? _c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'alt')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Alteração\n        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Processar Lote",
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getEsocialLotesProcessar,
      "onEdit": null,
      "onDelete": null,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingContent,
      "pagination": _vm.pagination
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60106157"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/processar/index.vue
// module id = 1442
// module chunks = 44